// poster_self_heal schema fragment. Runnable (no `runnable: false`): it runs on a
// schedule to detect id/title/year drift.

export const POSTER_SELF_HEAL_SCHEMA = {
    key: 'poster_self_heal',
    label: 'Poster Healer',
    // The healer can't resolve canonical ids/titles/years without TMDB — warn on
    // the config page when no key is set (ModuleSettingsPage reads `requires`).
    requires: [
        {
            field: 'tmdb.apikey',
            message:
                'The Poster Healer needs a TMDB API key to resolve canonical ids, titles, and years — without one, runs will do nothing.',
            linkTo: '/settings/general',
            linkText: 'Set it in General settings',
        },
    ],
    fields: [
        {
            // Read-only, live-computed — carries no config value of its own
            // (never calls onChange, so the key never lands in formData).
            key: 'assessed_locations',
            label: 'Assessed locations',
            type: 'poster_self_heal_coverage',
            section: 'Assessed locations',
            required: false,
        },
        {
            key: 'log_level',
            label: 'Log Level',
            type: 'dropdown',
            options: ['debug', 'info'],
            required: true,
            description:
                '"debug" logs every poster’s resolution; "info" is the normal cron-friendly level.',
        },
        {
            key: 'backfill_ids',
            label: 'Backfill missing IDs',
            type: 'check_box',
            description:
                'Also ADD resolved {tmdb-…}/{tvdb-…}/{imdb-…} ids to a poster that has none — not just correct posters that already carry an id. The source drive (CL2K output dir + Google Drive folder) comes from the CL2K Maker settings.',
        },
        {
            key: 'auto_apply',
            label: 'Auto-apply confident fixes',
            type: 'check_box',
            description:
                'Apply confident fixes automatically during the run (rename on Google Drive + locally) instead of waiting for manual review. Ambiguous matches — where a title matches more than one library item — always go to the review page regardless.',
        },
    ],
};

export const POSTER_SELF_HEAL_MODULE_ENTRY = {
    name: 'Poster Healer',
    key: 'poster_self_heal',
    description:
        'Keep your CL2K poster drive current — re-resolve each generated poster against TMDB and propose fixing stale ids, titles, and years, applied after manual review.',
};
